var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnDestroy, EventEmitter, OnInit } from '@angular/core';
import { openUploadWindow } from '../utils/open-upload-window';
import { readUploadedFolders } from '../utils/read-uploaded-folders';
var UploadDropzoneDirective = /** @class */ (function () {
    function UploadDropzoneDirective(el) {
        this.el = el;
        this.filesDropped = new EventEmitter();
        this.disableDropzoneClick = false;
        this.disableDropzone = false;
    }
    UploadDropzoneDirective.prototype.ngOnInit = function () {
        var _this = this;
        var el = this.el.nativeElement;
        el.addEventListener('dragenter', function (e) { return _this.handleDragEnter(e); });
        el.addEventListener('dragover', function (e) { return _this.handleDragOver(e); });
        el.addEventListener('dragleave', function (e) { return _this.handleDragLeave(e); });
        el.addEventListener('drop', function (e) { return _this.handleDrop(e); });
        if (!this.disableDropzoneClick) {
            el.addEventListener('click', function () { return _this.handleClick(); });
        }
    };
    UploadDropzoneDirective.prototype.ngOnDestroy = function () {
        this.removeClassesFromDropzone();
    };
    UploadDropzoneDirective.prototype.handleClick = function () {
        var _this = this;
        if (this.disableDropzone)
            return;
        openUploadWindow().then(function (files) {
            _this.emitUploadEvent(files);
        });
    };
    UploadDropzoneDirective.prototype.handleDragEnter = function (e) {
        if (this.dropzoneDisabled(e))
            return;
        this.el.nativeElement.classList.add('file-over-dropzone');
    };
    UploadDropzoneDirective.prototype.handleDragOver = function (e) {
        if (e.preventDefault)
            e.preventDefault();
        e.dataTransfer.dropEffect = this.dropzoneDisabled(e) ? 'none' : 'move';
        return false;
    };
    UploadDropzoneDirective.prototype.handleDragLeave = function (e) {
        var newEl = document.elementFromPoint(e.clientX, e.clientY);
        if (this.el.nativeElement.contains(newEl))
            return;
        this.removeClassesFromDropzone();
    };
    UploadDropzoneDirective.prototype.handleDrop = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var items, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        e.stopPropagation();
                        e.preventDefault();
                        this.removeClassesFromDropzone();
                        if (this.dropzoneDisabled(e) || !e.dataTransfer.items)
                            return [2 /*return*/];
                        items = Array.from(e.dataTransfer.items)
                            .filter(function (item) { return item.kind === 'file'; })
                            .map(function (item) {
                            return item.webkitGetAsEntry();
                        });
                        if (!items.length) return [3 /*break*/, 2];
                        _a = this.emitUploadEvent;
                        return [4 /*yield*/, readUploadedFolders(items)];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    UploadDropzoneDirective.prototype.emitUploadEvent = function (files) {
        this.filesDropped.emit(files);
    };
    UploadDropzoneDirective.prototype.removeClassesFromDropzone = function () {
        this.el.nativeElement.classList.remove('file-over-dropzone');
    };
    UploadDropzoneDirective.prototype.dropzoneDisabled = function (e) {
        var hasFiles = e.dataTransfer.types.find(function (type) { return type.toLowerCase() === 'files'; });
        return this.disableDropzone || !hasFiles;
    };
    return UploadDropzoneDirective;
}());
export { UploadDropzoneDirective };
